<template>
  <div v-if="canShowEditor" class="form-group">
    <ckeditor v-model="iValue" :editor="editor" :config="editorConfig" />
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import ImageInsert from '@ckeditor/ckeditor5-image/src/imageinsert'
import Image from '@ckeditor/ckeditor5-image/src/image'
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption'
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle'
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar'
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload'
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize'
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import Font from '@ckeditor/ckeditor5-font/src/font'
import Heading from '@ckeditor/ckeditor5-heading/src/heading'
import Media from '@ckeditor/ckeditor5-media-embed/src/mediaembed'
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting'
import ListProperties from '@ckeditor/ckeditor5-list/src/listproperties'
import Indent from '@ckeditor/ckeditor5-indent/src/indent'
import HtmlEmbed from '@ckeditor/ckeditor5-html-embed/src/htmlembed'
export default {
  components: {
    ckeditor: CKEditor.component
  },
  props: {
    value: { type: String, default: '' }
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          SourceEditing,
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          SimpleUploadAdapter,
          Image,
          ImageCaption,
          ImageStyle,
          ImageToolbar,
          ImageUpload,
          ImageInsert,
          ImageResize,
          LinkImage,
          Alignment,
          Font,
          Heading,
          Media,
          ListProperties,
          Indent,
          HtmlEmbed
        ],
        toolbar: {
          items: [
            'undo',
            'redo',
            '|',
            'heading',
            'fontSize',
            'fontFamily',
            'fontColor',
            '|',
            'bold',
            'italic',
            '|',
            'outdent',
            'indent',
            '|',
            'alignment:left',
            'alignment:right',
            'alignment:center',
            'alignment:justify',
            '|',
            'numberedList',
            'bulletedList',
            '|',
            'link',
            'insertImage',
            '|',
            'sourceEditing',
            'htmlEmbed'
          ],
          shouldNotGroupWhenFull: true
        },
        image: {
          toolbar: [
            'linkImage',
            'imageTextAlternative',
            'imageStyle:inline',
            'imageStyle:alignLeft',
            'imageStyle:alignRight',
            'imageStyle:alignCenter',
            'imageStyle:alignBlockLeft',
            'imageStyle:alignBlockRight',
            'imageStyle:block',
            'imageStyle:side'
          ]
        },
        fontSize: {
          options: [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 24, 30, 32, 36, 40, 48, 60]
        },
        simpleUpload: {
          uploadUrl: `${process.env.VUE_APP_BASE_API}api/v1/images/ckeditor-image`,
          headers: {
            'X-CSRF-TOKEN': 'CSRF-Token',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
          }
        }
      }
    }
  },
  computed: {
    iValue: {
      get() { return this.value },
      set(newValue) { this.$emit('input', newValue) }
    },
    canShowEditor() {
      return this.iValue !== null && typeof this.iValue !== 'undefined'
    }
  },
  mounted() {
    if (!this.canShowEditor) {
      this.iValue = ''
    }
  }
}
</script>